/* global windowWidth, breakpointMd */
/* eslint-disable */
$(function () {

  //  Verticle Tab
  $('.mod-tab .tab-nav__link').on('click', function () {
    if (windowWidth() > breakpointMd) {
      $(this).siblings().removeClass('is-active');
      $(this).addClass('is-active');
      var panelTarget = $(this).parents('.mod-tab').find("[data-target='" + $(this).attr('data-link') + "']");

      panelTarget.siblings().removeClass('is-active');
      panelTarget.addClass('is-active');
    } else {
      $(this).toggleClass('is-active');
      $(this).parents('.mod-tab__panel').siblings().find('.tab-nav__link').removeClass('is-active');
      $(this).parents('.mod-tab__panel').siblings().find('.mod-tab__panel-content').slideUp('fast');
      $(this).parents('.mod-tab__panel').find('.mod-tab__panel-content').slideToggle('fast');

      setTimeout(function () {
        $('html, body').animate({
          scrollTop: $(".mod-tab__panel .tab-nav__link.is-active").offset().top - 90
        }, 600);
      }, 400)
    }
  });
});
/* eslint-enable */
